var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.5H7V20.5C7 20.7652 6.89464 21.0196 6.70711 21.2071C6.51957 21.3946 6.26522 21.5 6 21.5H5C4.73478 21.5 4.48043 21.3946 4.29289 21.2071C4.10536 21.0196 4 20.7652 4 20.5V19.5H3V11.5H2V7.5H3V4.5C3 3.96957 3.21071 3.46086 3.58579 3.08579C3.96086 2.71071 4.46957 2.5 5 2.5H19C19.5304 2.5 20.0391 2.71071 20.4142 3.08579C20.7893 3.46086 21 3.96957 21 4.5V7.5H22V11.5H21V19.5H20V20.5C20 20.7652 19.8946 21.0196 19.7071 21.2071C19.5196 21.3946 19.2652 21.5 19 21.5H18C17.7348 21.5 17.4804 21.3946 17.2929 21.2071C17.1054 21.0196 17 20.7652 17 20.5V19.5ZM5 4.5V13.5H19V4.5H5ZM6 15.5C5.44772 15.5 5 15.9477 5 16.5C5 17.0523 5.44772 17.5 6 17.5H8C8.55228 17.5 9 17.0523 9 16.5C9 15.9477 8.55228 15.5 8 15.5H6ZM16 15.5C15.4477 15.5 15 15.9477 15 16.5C15 17.0523 15.4477 17.5 16 17.5H18C18.5523 17.5 19 17.0523 19 16.5C19 15.9477 18.5523 15.5 18 15.5H16Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusGrey);
export default __webpack_public_path__ + "static/media/bus_grey.50ebcff5ee3589bde35e7cd19ad3ad78.svg";
export { ForwardRef as ReactComponent };